export enum TimeTrackingTab {
  MY_TIMES = 'my-times',
  MY_TEAM = 'my-team',
  MY_ORDERS = 'my-orders',
  ALL_TIMES = 'all-times',
}

export enum TabViewType {
  WEEK = 'week',
  MONTH = 'month',
}

interface TabConfigEntry {
  viewType: TabViewType
  leaderOnly?: boolean
  maxDateRangeDays?: number
  toggle?: [
    { labelKey: string; value: string },
    { labelKey: string; value: string },
  ]
}

export const TAB_CONFIG: Record<TimeTrackingTab, TabConfigEntry> = {
  [TimeTrackingTab.MY_TIMES]: {
    viewType: TabViewType.WEEK,
    maxDateRangeDays: 7,
  },
  [TimeTrackingTab.ALL_TIMES]: {
    viewType: TabViewType.WEEK,
    leaderOnly: true,
  },
  [TimeTrackingTab.MY_TEAM]: {
    viewType: TabViewType.MONTH,
    leaderOnly: true,
    maxDateRangeDays: 31,
    toggle: [
      { labelKey: 'timeTracking.billing.hours', value: 'hours' },
      { labelKey: 'timeTracking.billing.days', value: 'days' },
    ],
  },
  [TimeTrackingTab.MY_ORDERS]: {
    viewType: TabViewType.MONTH,
    leaderOnly: true,
    maxDateRangeDays: 31,
    toggle: [
      { labelKey: 'timeTracking.billing.euros', value: 'euros' },
      { labelKey: 'timeTracking.billing.days', value: 'days' },
    ],
  },
}

export const TIME_TRACKING_CONSTANTS = {
  EXPECTED_WEEK_HOURS: 40,
  EXPECTED_DAY_HOURS: 8,
  ITEMS_PER_PAGE: 9,
  INITIAL_LIMIT: 50,
} as const

export const ERROR_MESSAGES = {
  FAILED_TO_GET_USER_ID: 'Failed to get current user ID',
  FAILED_TO_FETCH_TIME_RECORDS: 'Failed to fetch time records',
  FAILED_TO_FETCH_CLIENTS: 'Failed to fetch clients',
  FAILED_TO_FETCH_POSITIONS: 'Failed to fetch positions',
} as const

export enum ActivityType {
  BILLABLE = 'CSO_TIM_ACT_TYP_BIL',
  NON_BILLABLE = 'CSO_TIM_ACT_TYP_NON_BIL',
  SUPPORT = 'CSO_TIM_ACT_TYP_SUP',
  MANAGED_TEAM = 'CSO_TIM_ACT_TYP_MNG_TEA',
}

export const NO_LIMIT = { limit: '' } as object

export const MY_TEAM_CONSTANTS = {
  TARGET_HOURS_PER_MONTH: 160,
  HOURS_PER_DAY: 8,
  INITIAL_LIMIT: 50,
  PAGE_SIZE: 10,
  METRIC_COLUMNS_COUNT: 8,
} as const
